"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateProductList = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
/* istanbul ignore file */ const updateProductList = async (param)=>{
    let { customerId, globalApiClient, name, productListType, products, productList } = param;
    const items = products.filter((product)=>product.type === 'product').map((product)=>({
            itemCode: product.code
        }));
    const { created, customerId: listCustomerId, productListId } = productList !== null && productList !== void 0 ? productList : {};
    const parsedListCustomerId = Number.isInteger(listCustomerId) ? Number(listCustomerId) : undefined;
    if (!productListId || parsedListCustomerId === undefined) {
        return null;
    }
    const { data } = await (0, _globalApiClientReact.updateCustomerProductListTypeProductList)(globalApiClient, customerId, productListType, productListId, {
        items,
        created: created ? new Date(created) : undefined,
        customerId: parsedListCustomerId,
        name,
        productListId
    });
    return data;
};
exports.updateProductList = updateProductList;
